import title from './Title'
import subtitle from './Subtitle'
import p from './P'
import small from './Small'
import b from './B'

export const Title = title
export const Subtitle = subtitle
export const P = p
export const Small = small
export const B = b